/** Meta pixel "pixel riding instructor ready" (stockdigital.com, for the stockdigital 3 ad account).
 *  PageView on load, ViewContent when the offer section is seen, InitiateCheckout ONLY on the offer button. */
export const META_PIXEL_ID = '1621298972733754';
